import React, { useState, useEffect } from 'react';

const Signup = ({ onClose = () => {} }) => { // Default to empty function
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rePassword, setRePassword] = useState('');
  const [phone, setPhone] = useState('');
  const [isClosing, setIsClosing] = useState(false);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');

  const handleSignup = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    console.log('Validation errors:', validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      if (password !== rePassword) {
        setErrors({ rePassword: 'Passwords do not match' });
        return;
      }

      try {
        const response = await fetch('http://192.250.229.92:3002/signup', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ name, email, password, phone }),
        });

        const data = await response.json();
        console.log('Server response:', response.status, data);

        if (response.status === 201) {
          setMessage('Successful signup');
          console.log('Signup successful:', data.userId);
          setTimeout(() => onClose(), 2000); // Delay to show the message
        } else {
          setMessage(data.message || 'An error occurred');
        }
      } catch (error) {
        console.error('Error details:', error);
        setMessage('Failed to connect to the server');
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose(); // Safely call onClose
    }, 400);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        handleClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const validateForm = () => {
    const errors = {};

    if (!name.trim()) {
      errors.name = 'Name is required';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      errors.email = 'Email is required';
    } else if (!emailRegex.test(email)) {
      errors.email = 'Please enter a valid email address';
    }

    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
    if (!password) {
      errors.password = 'Password is required';
    } else if (!passwordRegex.test(password)) {
      errors.password = 'Password must be at least 8 characters long with letters, numbers, and a special character';
    }

    if (!rePassword) {
      errors.rePassword = 'Please re-enter your password';
    } else if (password !== rePassword) {
      errors.rePassword = 'Passwords do not match';
    }

    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!phoneRegex.test(phone)) {
      errors.phone = 'Please enter a valid 10-digit Indian phone number (starting with 6-9)';
    }

    return errors;
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 font-sans">
      <div
        className={`absolute inset-0 bg-black bg-opacity-70 transition-opacity duration-400 ease-in-out ${
          isClosing ? 'opacity-0' : 'opacity-100'
        }`}
        onClick={handleClose}
      ></div>

      <div
        className={`relative z-50 bg-black bg-opacity-80 p-8 rounded-lg w-full max-w-md text-white text-center shadow-lg ${
          isClosing ? 'animate-zoom-out' : 'animate-zoom-in'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-4 right-4 text-white hover:text-gray-300"
          onClick={handleClose}
        >
          ✕
        </button>

        <h2 className="mb-6 text-xl font-bold tracking-wide">
          SIGN UP TO VIRTUEISTA!
        </h2>

        <p className="mb-6 text-gray-400 text-sm">
          Learn & Earn. Become Expert.
        </p>

        <form onSubmit={handleSignup}>
          <div className="mb-6 text-left">
            <label className="block mb-2 text-sm font-medium text-gray-300">
              What's your name?
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name"
              className={`w-full p-3 rounded bg-gray-800 bg-opacity-80 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                errors.name ? 'border-red-500' : ''
              }`}
              required
              aria-required="true"
              aria-invalid={errors.name ? 'true' : 'false'}
              aria-describedby={errors.name ? 'name-error' : undefined}
            />
            {errors.name && (
              <p id="name-error" className="text-red-500 text-xs mt-1">
                {errors.name}
              </p>
            )}
          </div>

          <div className="mb-6 text-left">
            <label className="block mb-2 text-sm font-medium text-gray-300">
              What's your e-mail?
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-mail"
              className={`w-full p-3 rounded bg-gray-800 bg-opacity-80 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                errors.email ? 'border-red-500' : ''
              }`}
              required
              aria-required="true"
              aria-invalid={errors.email ? 'true' : 'false'}
              aria-describedby={errors.email ? 'email-error' : undefined}
            />
            {errors.email && (
              <p id="email-error" className="text-red-500 text-xs mt-1">
                {errors.email}
              </p>
            )}
          </div>

          <div className="mb-6 text-left">
            <label className="block mb-2 text-sm font-medium text-gray-300">
              Your password?
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className={`w-full p-3 rounded bg-gray-800 bg-opacity-80 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.password ? 'border-red-500' : ''
              }`}
              required
              aria-required="true"
              aria-invalid={errors.password ? 'true' : 'false'}
              aria-describedby={errors.password ? 'password-error' : undefined}
            />
            {errors.password && (
              <p id="password-error" className="text-red-500 text-xs mt-1">
                {errors.password}
              </p>
            )}
          </div>

          <div className="mb-6 text-left">
            <label className="block mb-2 text-sm font-medium text-gray-300">
              Re-enter password?
            </label>
            <input
              type="password"
              value={rePassword}
              onChange={(e) => setRePassword(e.target.value)}
              placeholder="Re-enter Password"
              className={`w-full p-3 rounded bg-gray-800 bg-opacity-80 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.rePassword ? 'border-red-500' : ''
              }`}
              required
              aria-required="true"
              aria-invalid={errors.rePassword ? 'true' : 'false'}
              aria-describedby={errors.rePassword ? 're-password-error' : undefined}
            />
            {errors.rePassword && (
              <p id="re-password-error" className="text-red-500 text-xs mt-1">
                {errors.rePassword}
              </p>
            )}
          </div>

          <div className="mb-6 text-left">
            <label className="block mb-2 text-sm font-medium text-gray-300">
              Phone Number
            </label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="98xxxxxxx"
              className={`w-full p-3 rounded bg-gray-800 bg-opacity-80 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                errors.phone ? 'border-red-500' : ''
              }`}
              required
              aria-required="true"
              aria-invalid={errors.phone ? 'true' : 'false'}
              aria-describedby={errors.phone ? 'phone-error' : undefined}
            />
            {errors.phone && (
              <p id="phone-error" className="text-red-500 text-xs mt-1">
                {errors.phone}
              </p>
            )}
          </div>

          <button
            type="submit"
            className="w-full p-3 bg-indigo-500 rounded text-white font-semibold hover:bg-indigo-600 transition-colors"
            disabled={Object.keys(errors).length > 0}
          >
            Start your learning journey
          </button>
        </form>

        {message && <p className="mt-4 text-green-500">{message}</p>}
      </div>

      <style jsx>{`
        @keyframes zoomIn {
          from {
            transform: scale(0.7) translateY(20px);
            opacity: 0;
          }
          to {
            transform: scale(1) translateY(0);
            opacity: 1;
          }
        }

        @keyframes zoomOut {
          from {
            transform: scale(1) translateY(0);
            opacity: 1;
          }
          to {
            transform: scale(0.7) translateY(20px);
            opacity: 0;
          }
        }

        .animate-zoom-in {
          animation: zoomIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }

        .animate-zoom-out {
          animation: zoomOut 0.4s cubic-bezier(0.36, 0, 0.66, -0.56) forwards;
        }
      `}</style>
    </div>
  );
};

export default Signup;